var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "form", attrs: { novalidate: "", action: _vm.action } },
    [
      _c(
        "div",
        { staticClass: "form--fieldset-row" },
        _vm._l(_vm.fieldsets, function(fieldset, fieldsetIdx) {
          return _c(
            "form-fieldset",
            _vm._b(
              { key: fieldsetIdx, staticClass: "form--fieldset" },
              "form-fieldset",
              _vm.bindFieldsetProps(fieldset),
              false
            )
          )
        })
      ),
      _vm._v(" "),
      _c("div", { staticClass: "form--fieldset-row" }, [
        _c(
          "div",
          { staticClass: "form--fieldset form-fieldset" },
          [
            _c("form-general-messages", {
              attrs: { errors: _vm.generalErrors }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2720780b", { render: render, staticRenderFns: staticRenderFns })
  }
}